var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { fileToBase64 } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
import { Portfolio } from '@/models/Portfolio';
let UploadFileDialog = class UploadFileDialog extends Vue {
    constructor() {
        super(...arguments);
        this.file = null;
        // protected fileString: string = '';
        this.inputElement = null;
        this.fileDescription = '';
        this.isUploading = false;
        this.isImage = false;
        this.imageMimeTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/tiff'];
        this.imageThumbnail = '';
        this.rules = {
            description: (value) => value.length <= 75 || 'Can\'t be longer then 75 characters',
        };
    }
    async inputChanged(event) {
        const files = event.target.files;
        this.inputElement = event.target;
        if (files === null || !files.length) {
            return;
        }
        this.isImage = this.imageMimeTypes.includes(files[0].type);
        this.file = files[0];
        // if image, create thumbnail with proper rotation;
        if (this.isImage) {
            const dataUrl = await fileToBase64(files[0]);
            this.imageThumbnail = dataUrl;
        }
    }
    rotateImage(dataUrl, orientation) {
        console.log('ROTATE', orientation);
    }
    close() {
        this.$emit('input', false);
    }
    async cleanImage(file) {
        const dataUrl = await fileToBase64(file);
        const image = new Image();
        const canvas = document.createElement('canvas');
        image.onload = async () => {
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                return;
            }
            ;
            ctx.drawImage(image, 0, 0);
            const response = await fetch(canvas.toDataURL('image/png'));
            const buffer = await response.arrayBuffer();
            const cleanFile = new File([buffer], file.name, { type: 'image/png' });
            this.saveToPortfolio(cleanFile);
        };
        image.src = dataUrl;
    }
    uploadFile() {
        if (!this.file) {
            return;
        }
        this.isUploading = true;
        if (this.isImage) {
            this.cleanImage(this.file);
        }
        else {
            this.saveToPortfolio(this.file);
        }
    }
    saveToPortfolio(file) {
        const payload = {
            file,
            collection: this.type === 'photo' ? 'photo-album' : 'cito-results',
            description: this.fileDescription,
        };
        new Portfolio()
            .uploadFileInPortfolio(this.portfolioId, payload)
            .then((response) => {
            if (response) {
                this.$emit('input', false);
                this.$emit('fileUploaded');
            }
            this.isUploading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isUploading = false;
        });
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], UploadFileDialog.prototype, "portfolioId", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], UploadFileDialog.prototype, "type", void 0);
UploadFileDialog = __decorate([
    Component({
        components: {},
    })
], UploadFileDialog);
export default UploadFileDialog;
